import React from 'react';
import ContentParser from '@ey-content-parser/core/es';
import { fetchDropdownOptions } from 'src/services/contentparser.service.js';
import accordionFactory from './elements/AccordionFactory';
import tableFactory from './elements/TableFactory';
import DropdownControl from './controls/DropdownControl';
import NumberControl from './controls/NumberControl';
import PercentageControl from './controls/PercentageControl';
import CheckboxControl from './controls/CheckboxControl';
import ConsentControl from './controls/ConsentControl';
import DateControl from './controls/DateControl';
import CurrencyControl from './controls/CurrencyControl';
import RadioControl from './controls/RadioControl';
import FileUploadControl from './controls/FileUploadControl';
import ReadOnlyControl from './controls/ReadOnlyControl';
import CustomTextControl from './controls/CustomTextControl';
import SearchAddControl from './controls/SearchAddControl';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';

export default function ContentParserWithComponents(props) {
  return (
    <ContentParser
      {...props}
      {...{
        fetchDropdownOptions,
        accordionFactory,
        tableFactory,
        DropdownControl,
        NumberControl,
        PercentageControl,
        CheckboxControl,
        ConsentControl,
        DateControl,
        CurrencyControl,
        RadioControl,
        FileUploadControl,
        ReadOnlyControl,
        CustomTextControl,
        SearchAddControl,
        InfoTooltip,
      }}
    />
  );
}
